import { MOODS_MIXPANEL_CONSTANT } from '@libs/constants';
import { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EVENT } from '../../../../contexts/MixpanelConstants';
import { MixpanelContext } from '../../../../contexts/MixpanelContext';
import { getMixpanelLinearProperties, getMixpanelVodProperties } from '../../../../contexts/MixpanelHelper';
import { setMoodCategory } from '../../../../store/reducers/moodsRecommendationSlice';
import { __ } from '../../../../translations';
import { IMixpanelContext } from '../interface';
import CarouselWrapper from './CarouselWrapper';
import { getListing, getLoader } from './getListing';

const MoodCategory = ({ mood, onChangeMood, Component, titleKey, getCategories, loading, isVod = false }) => {
    const { track } = useContext(MixpanelContext) as IMixpanelContext;
    const [selectedCategory, setSelectedCategory] = useState(null);
    const dispatch = useDispatch();
    const moodCategoryState = useSelector((state: any) => state.moodsRecommendation.moodCategory);
    const categories = getCategories(mood);

    const categoryClickHandler = (id: string) => {
        const category = categories.find((el) => el.id === id);
        setSelectedCategory(category);
        dispatch(setMoodCategory(category?.id || null));

        // Mixpanel Event
        track(EVENT.MOODS.MOOD_CATEGORY_SELECT, {
            'Mood Type': MOODS_MIXPANEL_CONSTANT[mood?.type || ''],
            'Mood Category': category?.filterName || '',
        });
    };

    const sendMPEventOnItemClick = (item, index) => {
        track(EVENT.MOODS.MOOD_ITEM_CLICK, {
            'Mood Type': MOODS_MIXPANEL_CONSTANT[mood?.type || ''],
            'Mood Category': selectedCategory?.filterName || '',
            ...(isVod ? getMixpanelVodProperties(item) : getMixpanelLinearProperties(item)),
            'Row Index': index,
        });
    };

    useEffect(() => {
        if (moodCategoryState && Array.isArray(categories) && categories.length > 0 && !selectedCategory) {
            const category = categories.find((el) => el.id === moodCategoryState);
            setSelectedCategory(category);
        }
    }, [moodCategoryState, categories]);

    return selectedCategory ? (
        <Component category={selectedCategory} onChangeMood={onChangeMood} onItemClick={sendMPEventOnItemClick} />
    ) : (
        <CarouselWrapper title={__(titleKey)} onChangeMood={onChangeMood}>
            {loading ? getLoader(4) : getListing(categories, categoryClickHandler)}
        </CarouselWrapper>
    );
};

export default MoodCategory;
